<template>
  <img :src="require('@/assets/logo.svg')" />
</template>
